import { createLanding } from "layout/landing/landing";
import { createCalculator } from "modules/calculator/calculator";
import { createSectionBlog } from "page-sections/section-blog";
import { createReviews } from "page-sections/section-reviews";

createLanding();
createSectionBlog();
createReviews();
createCalculator();
